module.exports = __webpack_public_path__ + "admin-thumbs/s-text-info-block.png";